// import { useState } from 'react';
import { Form, Radio } from 'antd';
import { TagInput } from '@douyinfe/semi-ui';
import classes from './BillAdress.module.css';
import { BILL_EMAIL_LIST } from './const';

export default function BillingEmail() {
  // const form = Form.useFormInstance();

  // const [email, setEmail] = useState([]);
  // const [cc, setCc] = useState([]);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const emailValidator = (rule, value, callback, type) => {
    const lastValue = value ? value[value.length - 1] : '';

    // 邮箱正则表达式
    if (type === 1 && !value?.length) {
      return Promise.reject(new Error('Please enter a email address'));
    }
    if (value && value.length && !emailRegex.test(lastValue)) {
      return Promise.reject(new Error('Please enter a valid email address'));
    }
    console.log('email valid');
    return Promise.resolve();
  };
  // const handleChange = (type, value) => {
  //   const validateEmail = value.filter((item) => emailRegex.test(item));
  //   if (type === 1) {
  //     setEmail(validateEmail);
  //     form.setFieldValue('email', validateEmail);
  //   } else {
  //     setCc(validateEmail);
  //     form.setFieldValue('cc', validateEmail);
  //   }
  // };

  // const handleAdd = (value, type) => {
  //   console.log(value, 'add add');
  //   const validateEmail = value.filter((item) => emailRegex.test(item));
  //   if (type === 1) {
  //     setEmail(validateEmail);
  //     form.setFieldValue('email', validateEmail);
  //   } else {
  //     setCc(validateEmail);
  //     form.setFieldValue('cc', validateEmail);
  //   }
  // };

  return (
    <div className={classes.container}>
      <Form.Item noStyle className={classes.radio_group} name="billEmailType">
        <Radio.Group>
          {BILL_EMAIL_LIST.map(({
            value, label,
          }) => (
            <div className={classes.radio} key={value}>
              <Radio value={value}>
                <div className={classes.radio_title}>
                  {label}
                </div>
              </Radio>
            </div>
          ))}
        </Radio.Group>
      </Form.Item>
      <div className={classes.content}>
        <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.billEmailType !== currentValues.billEmailType} style={{ marginBottom: 0 }} className="special_form_item">
          {({ getFieldValue }) => {
            const billEmailType = getFieldValue('billEmailType');
            if (billEmailType === 2) {
              return (
                <div className={classes.email}>
                  <Form.Item
                    label=""
                    name="email"
                    // noStyle
                    rules={[
                      {
                        validator: (rule, value, callback) => emailValidator(rule, value, callback, 1),
                      },
                    ]}
                  >
                    <TagInput
                      className={classes.email_input}
                      // value={email}
                      addOnBlur
                      prefix="To"
                      // onAdd={(v) => handleAdd(v, 1)}
                      // onChange={(v) => handleChange(1, v)}
                      allowDuplicates={false}
                    />
                  </Form.Item>

                  <Form.Item
                    label=""
                    name="cc"
                    // noStyle
                    rules={[
                      {
                        validator: emailValidator,
                      },
                    ]}
                    shouldUpdate
                  >
                    <TagInput
                      className={classes.email_input}
                      addOnBlur
                      // value={cc}
                      prefix="Cc"
                      // onChange={(v) => handleChange(2, v)}
                      allowDuplicates={false}
                    />
                  </Form.Item>

                </div>
              );
            }
            return null;
          }}
        </Form.Item>
      </div>

    </div>
  );
}
